export const contracts = '/contracts'
export const contractInfo = '/contractInfo'
export const suspendedContract = '/suspendedContract'

